var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "feedback-popup", class: { focused: _vm.focused } },
    [
      _vm.show_form
        ? _c(
            "div",
            [
              _c("masking", {
                staticClass: "feedback-mask",
                attrs: { zindex: 10 }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "feedback-form" }, [
                _c("div", { staticClass: "form-wrap" }, [
                  _c(
                    "a",
                    {
                      staticClass: "close-form",
                      attrs: { href: "javascript:void(0);" },
                      on: { mousedown: _vm.preventBlur, click: _vm.onClose }
                    },
                    [_c("i", { staticClass: "iconfont icon-c-close" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-header" },
                    [
                      _c("h2", [_vm._v("问题/建议反馈")]),
                      _vm._v(" "),
                      _c(
                        "x-button",
                        {
                          staticClass: "submit-feedback",
                          attrs: {
                            mini: "",
                            type: "primary",
                            disabled: !_vm.content || _vm.submitting
                          },
                          nativeOn: {
                            mousedown: function($event) {
                              return _vm.preventBlur.apply(null, arguments)
                            },
                            click: function($event) {
                              return _vm.submitFeedback.apply(null, arguments)
                            }
                          }
                        },
                        [_vm._v("反馈")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-body" },
                    [
                      _c("x-textarea", {
                        staticClass: "form-content",
                        attrs: {
                          "show-counter": false,
                          placeholder: _vm.placeholder,
                          height: 204,
                          disabled: _vm.submitting
                        },
                        on: { "on-focus": _vm.onFocus, "on-blur": _vm.onBlur },
                        model: {
                          value: _vm.content,
                          callback: function($$v) {
                            _vm.content = $$v
                          },
                          expression: "content"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "faq-links" },
                    [
                      _c("cell", {
                        attrs: {
                          title: "教师常见问题解决方法",
                          "data-baidu": "反馈表单|教师常见问题",
                          "data-event": "反馈表单|教师常见问题",
                          "is-link": ""
                        },
                        nativeOn: {
                          click: function($event) {
                            return _vm.goFaq("teacher")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("cell", {
                        attrs: {
                          title: "家长常见问题解决方法",
                          "is-link": "",
                          "data-baidu": "反馈表单|家长常见问题",
                          "data-event": "反馈表单|家长常见问题"
                        },
                        nativeOn: {
                          click: function($event) {
                            return _vm.goFaq("parents")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.is_teacher_admin
                        ? _c("cell", {
                            attrs: {
                              "data-baidu": "反馈表单|加入群聊",
                              "data-event": "反馈表单|加入群聊",
                              title: "加入【群聊】交流反馈",
                              "is-link": ""
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.goJoinGroup.apply(null, arguments)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        : _vm.trigger && !_vm.show_form
        ? [
            _c(
              "div",
              {
                staticClass: "feedback-trigger",
                on: {
                  click: function($event) {
                    _vm.show_form = true
                  }
                }
              },
              [
                _vm._t("trigger", function() {
                  return [_vm._m(0)]
                })
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "default-trigger",
        attrs: { href: "javascript:void(0);" }
      },
      [_c("i", { staticClass: "iconfont icon-c-feedback" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13df3d2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13df3d2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/el-feedback-popup.vue
// module id = null
// module chunks = 